import { Component, Input } from '@angular/core';
import {MatDialogRef} from "@angular/material";

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: 'confirm.component.html',
})
export class ConfirmComponent {
    constructor(
        public dialogRef: MatDialogRef<ConfirmComponent>
    ) {}

    public confirmMessage: string;
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/dialogs/confirm/confirm.component.ts